import {NgModel} from '@angular/forms';

import {ValueAccessorBase} from './value.accessor.base';


export abstract class ElementBase<T> extends ValueAccessorBase<T> {
  protected abstract model: NgModel;

}
